import { playerName } from '../utils/galiDisplay';
const GaliAccessList = ({ access = [], onRevoke }) => (
  <section className="gali-card">
    <h2 className="h5">Current access</h2>
    <div className="gali-player-list">
      {access.length ? access.map((item) => (
        <div className="gali-player-row" key={item.id || item._id || item.userId}>
          <span>{playerName(item.user || item)} <span className="badge text-bg-light">{item.role || 'viewer'}</span></span>
          <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => onRevoke?.(item.userId || item.user?._id || item.user?.id)}>Remove access</button>
        </div>
      )) : <p className="text-muted mb-0">No extra access entries.</p>}
    </div>
  </section>
);
export default GaliAccessList;
